import React, { useCallback, useMemo, useState } from 'react';
import styles from 'src/styles/layout.module.css';
import { Space, Typography } from 'antd';
import InputEditableField from '../../../../fields/InputEditableField';
import TextareaEditableField from '../../../../fields/TextareaEditableField';
import SelectEditableField from '../../../../fields/SelectEditableField';
import {
  ContentCard,
  ContentQuality,
  VideoResolution,
  VRFormat,
  VRType,
} from '../../../../../features/contents/contents.types';
import SwitchSelectField from '../../../../fields/SwitchSelectField';
import { updateContent } from '../../../../../features/contents/contents.state';
import { useParams } from 'react-router-dom';
import { AppDispatch } from '../../../../../index';
import { useDispatch } from 'react-redux';
import { useContentById } from '../../../../../features/contents/contents.hooks';

const ContentCardDetailsTab: React.FC = () => {
  const { contentId } = useParams() as { contentId: string };
  const dispatch: AppDispatch = useDispatch();
  const content = useContentById(contentId) as ContentCard;

  const vrFormatOptions = useMemo(
    () => [
      { label: 'Обычное 2D', value: VRFormat.twoD },
      { label: 'Вертикальное 3D', value: VRFormat.threeDVertical },
      { label: 'Горизонтальное 3D', value: VRFormat.threeDHorizontal },
    ],
    []
  );
  const vrTypeOptions = useMemo(
    () => [
      { label: 'NONE', value: VRType.NONE },
      { label: '180°', value: VRType.VR180 },
      { label: '360°', value: VRType.VR360 },
    ],
    []
  );
  const videoResolutionOptions = useMemo(
    () => [
      { label: 'HD', value: VideoResolution.HD },
      { label: 'FULL HD', value: VideoResolution.FULL_HD },
      { label: '2K HD', value: VideoResolution.HD_2K },
      { label: '4k HD', value: VideoResolution.HD_4K },
    ],
    []
  );

  const qualityOptions = useMemo(
    () => [
      { label: 'Нормальное', value: ContentQuality.NORMAL },
      { label: 'Хорошее', value: ContentQuality.GOOD },
      { label: 'Высокое', value: ContentQuality.BEST },
    ],
    []
  );
  const handleCardUpdate = useCallback(
    (data: Partial<ContentCard>) => {
      dispatch(updateContent({ contentId, data }));
    },
    [contentId, dispatch]
  );

  return (
    <Space direction={'vertical'} style={{ width: '100%' }}>
      <Typography.Text className={styles.title}>Description</Typography.Text>
      <InputEditableField value={content.description as string} onBlur={e => handleCardUpdate({ description: e })} />
      <Typography.Text className={styles.title}>Разрешение</Typography.Text>
      <SelectEditableField
        value={content.resolution as string}
        options={videoResolutionOptions}
        onSelect={e => handleCardUpdate({ resolution: e as VideoResolution })}
      />
      <Typography.Text className={styles.title}>URL</Typography.Text>
      <TextareaEditableField value={content.cloudUrl} onBlur={e => handleCardUpdate({ cloudUrl: e })} />
      <Typography.Text className={styles.title}>HD URL</Typography.Text>
      <TextareaEditableField value={content.hdUrl} onBlur={e => handleCardUpdate({ hdUrl: e })} />
      <Typography.Text className={styles.title}>FULL HD URL</Typography.Text>
      <TextareaEditableField value={content.fullHdUrl} onBlur={e => handleCardUpdate({ fullHdUrl: e })} />
      <Typography.Text className={styles.title}>2K URL</Typography.Text>
      <TextareaEditableField value={content.hd2kUrl} onBlur={e => handleCardUpdate({ hd2kUrl: e })} />
      <Typography.Text className={styles.title}>4K URL</Typography.Text>
      <TextareaEditableField value={content.hd4kUrl} onBlur={e => handleCardUpdate({ hd4kUrl: e })} />
      <Typography.Text className={styles.title}>Путь к контенту</Typography.Text>
      <TextareaEditableField value={content.uri} onBlur={e => handleCardUpdate({ uri: e })} />
      <SelectEditableField
        value={content.vrType as string}
        options={vrTypeOptions}
        onSelect={e => handleCardUpdate({ vrType: e as VRType })}
      />
      <Typography.Text className={styles.title}>VR Формат</Typography.Text>
      <SelectEditableField
        value={content.vrFormat as string}
        options={vrFormatOptions}
        onSelect={e => handleCardUpdate({ vrFormat: e as VRFormat })}
      />
      <Typography.Text className={styles.title}>Качество</Typography.Text>
      <SelectEditableField
        value={content.quality as string}
        options={qualityOptions}
        onSelect={e => handleCardUpdate({ quality: e as ContentQuality })}
      />
      <Typography.Text className={styles.title}>Заблокирован</Typography.Text>
      <SwitchSelectField value={content.disabled} onSelect={e => handleCardUpdate({ disabled: e })} />
      <Typography.Text className={styles.title}>Локальный</Typography.Text>
      <SwitchSelectField value={content.isLocal} onSelect={e => handleCardUpdate({ isLocal: e })} />
      <Typography.Text className={styles.title}>Upscale</Typography.Text>
      <SwitchSelectField value={content.upscale} onSelect={e => handleCardUpdate({ upscale: e })} />
    </Space>
  );
};
export default ContentCardDetailsTab;
